// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","330":"ecf94ad3","523":"1ffe7e97","524":"3f321976","573":"a82f069e","933":"f1705488"}[chunkId] + ".chunk.js";
};